import { render, staticRenderFns } from "./InfoEditor.vue?vue&type=template&id=4ca545ce&"
import script from "./InfoEditor.vue?vue&type=script&lang=js&"
export * from "./InfoEditor.vue?vue&type=script&lang=js&"
import style0 from "./InfoEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports